import { Fab } from "@mui/material";
import WheelIcon from "../../svg/wheel-ico.png";
import "./Wheel.css";

export default function WheelBackButton(props) {
    return (
        <>
            <Fab
                // variant="extended"
                // size="medium"
                color="primary"
                aria-label="add"
                sx={{
                    height: "75px",
                    width: "75px",
                    position: "fixed",
                    bottom: "80px",
                    right: "7px",
                    zIndex: 1000,
                    backgroundColor: "white",
                    color: "black",
                    display: window.location.href.includes("/subject") || window.location.href.includes("/tools/")? "inline-flex" : "none",
                    "&:hover": {
                        backgroundColor: "white",
                        color:  "black",
                    },
                }}
                onClick={() => window.location.href = toolkitData.root_url + "/find-a-tool/"}
            >
                <img 
                    src={WheelIcon} 
                    style={{width: "75px", height: "75px"}}/>
            </Fab>
            
            {/* <img style="width: 50px; height: 50px;" src="../../svg/wheel-ico.svg" alt=""></img> */}
            {/* <Icon><img src="../../svg/wheel-ico.svg"/></Icon> */}
        </>
    );
}